import { useTranslation } from "react-i18next";
import { FCC } from "types";

import { BlueSidemenuBlob } from "@/components/Layout/BlueSidemenuBlob/BlueSidemenuBlob";
import { CollapsibleLanguageMenu } from "@/components/Layout/Footer/CollapsibleLanguageMenu";
import { CollapsibleLinkMenu } from "@/components/Layout/Footer/CollapsibleLinkMenu";
import { SupportLinkItem } from "@/components/Layout/Footer/SupportLinkItem";
import { getCurrentVersion } from "@/utils/versionCheck";

export const Sidemenu: FCC = ({ children }) => {
  const { t } = useTranslation();
  const version = getCurrentVersion();

  return (
    <div className="absolute bottom-0 left-0 h-[70vh] max-h-[756px] w-[474px] pb-10 pt-32">
      <BlueSidemenuBlob />
      <nav
        className="fixed bottom-0 left-0 z-30 ml-10 flex h-[inherit] w-44 flex-col justify-between gap-8 pt-36"
        id="menu-items"
      >
        {children}
        <div className="mb-10 mt-auto flex flex-row items-center gap-4">
          <CollapsibleLanguageMenu />
          <SupportLinkItem />
          <CollapsibleLinkMenu />
        </div>
        <div className="text-xs text-white text-opacity-75">
          {t("Footer.version")} {version}
        </div>
      </nav>
    </div>
  );
};
